import { render, staticRenderFns } from "./tabRight.vue?vue&type=template&id=7c188b3f&scoped=true&"
import script from "./tabRight.vue?vue&type=script&lang=js&"
export * from "./tabRight.vue?vue&type=script&lang=js&"
import style0 from "./tabRight.vue?vue&type=style&index=0&id=7c188b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c188b3f",
  null
  
)

export default component.exports